/** True when a key press belongs to a text control, not to the app shortcuts. */
export function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT";
}

const IS_MAC = /Mac|iPhone|iPad/.test(
  typeof navigator === "undefined" ? "" : navigator.platform || navigator.userAgent,
);

/** The Cmd/Ctrl+K hint as drawn on this platform. */
export const MOD_KEY_LABEL = IS_MAC ? "⌘K" : "Ctrl K";

/** True for the Cmd/Ctrl+K chord. */
export const isSearchChord = (e: KeyboardEvent): boolean =>
  (e.metaKey || e.ctrlKey) && !e.altKey && e.key.toLowerCase() === "k";
